module.exports = __webpack_public_path__ + "static/telekino-2feccb478cf9dfef4ea53f3d1f637be8.svg";